// extracted by mini-css-extract-plugin
export var billingAddress = "_re-g";
export var contactInfo = "_re-d";
export var customerInfoContainer = "_re-c";
export var customerInfoContainerMobile = "_re-h";
export var customerInfoRow = "_re-a";
export var customerInfoSection = "_re-b";
export var fullWidthDividerMobile = "_re-i";
export var imageContainer = "_re-1";
export var paymentMethod = "_re-e";
export var priceText = "_re-6";
export var priceTextMobile = "_re-7";
export var product = "_re-0";
export var productImage = "_re-2";
export var productInfo = "_re-4";
export var productMobile = "_re-9";
export var productTitle = "_re-8";
export var quantityBadge = "_re-3";
export var quantityText = "_re-5";
export var shippingAddress = "_re-f";